export const api = process.env.NODE_ENV === "production" ? "https://apiecommerce.juliafloresrj.com.br" : "http://localhost:3000";
export const versao = "v1";
export const loja = "https://loja.juliafloresrj.com.br";
export const apiLinkImages = "https://apiecommerce.juliafloresrj.com.br";
export const merchantCenterAccountId = "526699962";
